import { useQuery, gql, useLazyQuery } from '@apollo/client';
import { FeriadosPageQuery, FeriadosPageQueryVariables } from './__generated__/FeriadosPageQuery';

const FERIADOS_QUERY = gql`
  query FeriadosPageQuery($descricao: String, $pagina: Int, $itens_por_pagina: Int) {
    feriados(
      filter: { descricao: $descricao, pagina: $pagina, itens_por_pagina: $itens_por_pagina }
    ) {
      id_feriado
      dsc_feriado
      dat_feriado
    }
  }
`;

const useFeriadosPageQuery = (variables: FeriadosPageQueryVariables) => {
  return useQuery<FeriadosPageQuery, FeriadosPageQueryVariables>(FERIADOS_QUERY, {
    variables,
  });
};

const useFeriadosLazyQuery = () => {
  return useLazyQuery<FeriadosPageQuery, FeriadosPageQueryVariables>(FERIADOS_QUERY);
};

export { useFeriadosPageQuery, useFeriadosLazyQuery };
